import { IJSLComponent, IJSLVNode, IJSLAnimation } from "jsl-render";
import { date, StackPanelComponent } from "jsl-ui";
import { NivEventEntry } from "../../ajax/types/NivEventEntry";
import { NivEventStatus } from "../../ajax/types/NivEventStatus";
import { mapUrl } from "../../helper/mapUrl";
import { GenerateTrackingUrl } from "../../helper/tracking";

export class StatusEntryComponent implements IJSLComponent {

    public State = { animationDone: false };

    public constructor(private entry: NivEventEntry, private index: number) {
    }

    public render(): IJSLVNode {
        let animation: IJSLAnimation = {
            attr: "left",
            from: "-110%",
            to: "0%",
            duration: 500,
            delay: 200 * this.index,
            easing: "easeOutExpo"
        };
        if (this.State.animationDone) {
            animation = null;
        }
        if (this.entry.Status === NivEventStatus.Done) {
            return this.getStackPanelWithImage("Content/images/ticck.png", animation);
        } else {
            return this.getStackPanelWithImage("Content/images/hourglass.png", animation, [235, 235, 235]);
        }
    }

    public onCreate() {
        // if (this.animate) {
            this.State.animationDone = true;
        // }
    }

    private getStackPanelWithImage(url: string, animation: IJSLAnimation, background?: number[]) {
        let dateString: string = "";
        if (date.format(this.entry.Occured) !== "") {
            dateString += date.format(this.entry.Occured);
        }
        let backgroundString: string = "";
        if (background !== undefined) {
            backgroundString = "background:rgb(" + background[0] + ", " + background[1] + ", " + background[2] + ")";
        } else {
            backgroundString = "";
        }
        return (<div style={{
            left: animation ? "-110%" : "0%",
            position: "relative"
        }} animation={animation}>{
                new StackPanelComponent(
                    [
                        <div class="status-entry-info">
                            <img src={mapUrl(url)} style="max-width:2.2rem; max-height: 2.2rem;"></img>
                        </div>,
                        <div class="info-box status-entry-info" style={backgroundString}>
                            {new StackPanelComponent([
                                <div><div>{this.entry.Text}</div>
                                    {this.entry.PaketNr ? GenerateTrackingUrl(this.entry.PaketNr, this.entry.Logistikanbieter) : undefined}</div>,
                                <div>{dateString}</div>
                            ],
                                {
                                    valign: "top",
                                    sizes: [undefined, "*"]
                                }
                            )}
                        </div>
                    ],
                    {
                        responsive: false,
                        sizes: ["*"],
                        valign: "center"
                    }
                )
            }</div>);
    }
}
